import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserActivityReports } from "../../../store/slices/fault-module/user-activity.slice";
import UserActivityReportTableComponent from "./user-activity-report-table.component";
import TableSort from "../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../shared/helpers/upper-case";

const UserActivityReportComponent = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const pageSize = 10;

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("Timestamp"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const filter = useSelector((state: any) => {
    return state.userActivityReport.filter;
  });

  const [columns, setColumns] = useState([
    {
      title: "User",
      label: "userName",
    },
    {
      title: "Report Date",
      label: "timestamp",
      type: "datetime",
      isSorted: true,
    },
    // {
    //   title: "Report Time",
    //   label: "reportTime",
    // },
    // {
    //   title: "User Event",
    //   label: "userEvent",
    // },
    {
      title: "Activity",
      label: "activityMessage",
    },
  ]);

  const dispatch = useDispatch();

  const userActivityReportData = useSelector((state: any) => {
    return state.userActivityReport.userActivityReports;
  });

  const onRefetchData = (
    // tcCode = null,
    // siteCode = null,
    // blockCode = null,
    userId = null,
    startDate = null,
    endDate = null
  ) => {
    setPageNum(1);
    dispatch(
      getUserActivityReports({
        PageNumber: 1,
        pageSize,
        // tcCode,
        // siteCode,
        // blockCode,
        userId,
        startDate,
        endDate,
        SortBy,
        SortDirection,
      })
    );
  };

  // useEffect(() => {
  //   onRefetchData();
  // }, [dispatch, PageNumber, SortBy, SortDirection]);

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  useEffect(() => {
    let {
      // townCouncil,
      // site,
      // block,
      // reportType,
      startDate,
      endDate,
      userId,
    } = filter;

    if (startDate) {
      dispatch(
        getUserActivityReports({
          PageNumber: PageNumber,
          pageSize,
          userId: userId || null,
          startDate: startDate || null,
          endDate: endDate || null,
          SortBy,
          SortDirection,
        })
      );
    }
  }, [dispatch, PageNumber, SortBy, SortDirection]);

  useEffect(() => {
    setPageNum(1);
  }, [filter]);

  return (
    <div>
      <UserActivityReportTableComponent
        columns={columns}
        data={userActivityReportData?.data}
        totalNumberOfRecords={userActivityReportData?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
      />
    </div>
  );
};

export default UserActivityReportComponent;
